module.exports = __webpack_public_path__ + "static/media/8OLA31.6f2018cb.jpg";